(() => {
  angular
    .module('kareo.ui.shared.modules.api.provider.k-provider-service', [])
    .factory('providerService', providerService);

  providerService.$inject = ['$http'];
  function providerService($http) {
    let defaultUrl;
    defaultUrl = '/admin-ui/api/Provider';
    return {
      getDefaultUrl: () => {
        return defaultUrl;
      },
      getAllProviders: source => {
        let allProviderUrl;
        if (source) {
          allProviderUrl = defaultUrl + '/source/' + source;
        } else {
          allProviderUrl = defaultUrl + '/all';
        }
        return $http.get(allProviderUrl)
          .then(response => {
            return response.data;
          });
      },
      getProviderProducts: (providerGuid) => {
        return $http.get(defaultUrl + '/' + providerGuid + '/products')
          .then(response => {
            return response.data;
          });
      },
      getProviderByGuid: providerGuid => {
        return $http.get(defaultUrl + '/' + providerGuid)
          .then(response => {
            return response.data;
          });
      },
      getAllFeaturesOfOneProvider: providerGuid => {
        return $http.get(defaultUrl + '/' + providerGuid + '/features')
          .then(response => {
            return response.data;
          });
      },
      getMyFeatures: () => {
        return $http.get(defaultUrl + '/my/features')
          .then(response => {
            return response.data;
          });
      },
      getAllFeaturesOfAllProviders: () => {
        return $http.get(defaultUrl + '/features/all')
            .then(response => {
              return response.data;
            });
      },
      lookupNpi: npi => {
        return $http
          .get('/admin-ui/api/Shared/lookupNpi', {
            cache: true,
            params: {
              npi
            }
          })
          .then(response => response.data);
      },
      getProviderByUserGuid: (userGuid) => {
        return $http
          .get('/admin-ui/api/Provider', {
            params: {
              userGuid
            }
          })
          .then(response => response.data);
      }
    };
  }
})();
